import CustomsLabel from "./CustomsLabel";

export default CustomsLabel;
